
      import Check from './check.vue'
      import type { App, Plugin } from 'vue'

      export const CheckPlugin: Plugin = {
        install(app: App) {
          app.component('Check', Check)
        },
      }
      export { Check }
      